export default function desc(a: number | any, b: number | any) {
	return a >= b ? -1 : 1
}
